import { render, staticRenderFns } from "./VynosCV.vue?vue&type=template&id=07b8280c&"
import script from "./VynosCV.vue?vue&type=script&lang=ts&"
export * from "./VynosCV.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports